import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import deeplinksUtil from '../../util/deeplinks.util'

export class NextStepHint extends React.Component {
    constructor(props) {
        super(props)
    }	

    shouldComponentUpdate(nextProps, nextState) {
        if ( 
            this.props.leg.get('accommodations').size == nextProps.leg.get('accommodations').size &&
      this.props.leg.get('activities').size == nextProps.leg.get('activities').size &&
      this.props.leg.get('transportation').size == nextProps.leg.get('transportation').size
        ) {      
            return false
        }
    }

    getContent() {
        let accommodationCount = this.props.leg.get('accommodations').size
        let activityCount = this.props.leg.get('activities').size
        let travelCount = this.props.leg.get('transportation').size

        let renderList = []
        let deepLinkData = {
            'leg': this.props.leg,
            'subsection': 'OVERVIEW'
        }

        if (accommodationCount == 0) {
            deepLinkData.section = 'ACCOMMODATIONS'
            renderList.push({
                msg: 'You don\'t have any hotels picked out. Look for places to say in the accommodations section.',
                deeplink: deeplinksUtil.pushDeepLink('UISTATUS', deepLinkData, false)
            })
        }
        if (activityCount == 0) {
            deepLinkData.section = 'ACTIVITIES'
            renderList.push({
                msg: 'You have no activities planned for this location. Click on activities to explore things to do.',
                deeplink: deeplinksUtil.pushDeepLink('UISTATUS', deepLinkData, false)
            })
        }
        if (travelCount == 0) {
            deepLinkData.section = 'TRAVEL'
            renderList.push({
                msg: 'Wondering how to get to this destination? Look up travel options in the transportation section.',
                deeplink: deeplinksUtil.pushDeepLink('UISTATUS', deepLinkData, false)
            })
        }

        if (renderList.length > 0) {
            let hintIndex = Math.floor(Math.random() * renderList.length)
            // in the event we actually pull a 1 on random()
            if (hintIndex == renderList.length) {
                hintIndex = renderList.length - 1
            }
            return (
                <div className="next-step">
                    <i className="icon icon-notifications"/>
                    <span>{renderList[hintIndex].msg}</span><br/>
                    <a href={renderList[hintIndex].deeplink}>Go there now <i className="icon icon-arrow_right_a"/></a>
                </div>
            )
        } else {
            return null
        }
    }

    render() {
        if (this.props.leg && this.props.inItin) {
            return ( 
                <div>     
                    {this.getContent()}
                </div>
            )
        } else {
            return null
        }
    }
}
